export class AuthenticationCredentials {
  username: string;
  password: string;
}
